<template>
  <div>
    <div>
      <div class="input-item">
        <div class="label">学生姓名</div>
        <input type="text" v-model="name" placeholder="请输入学生姓名" />
      </div>
      <div class="input-item">
        <div class="label">学生性别</div>
        <div class="sex-select">
          <div class="sex-item boy" :class="{ active: sex === 1 }" @click="sex = 1">男</div>
          <div class="sex-item gril" :class="{ active: sex === 2 }" @click="sex = 2">女</div>
        </div>
      </div>
      <div class="input-item" @click="school_show = true">
        <div class="label">选择学校</div>
        <input type="text" placeholder="请选择学校" :value="schoolname" readonly />
        <img :src="IconRight" class="right-icon" />
      </div>
      <div class="input-item" @click="class_show = true">
        <div class="label">选择班级</div>
        <input type="text" placeholder="请选择班级" :value="class_text" readonly />
        <img :src="IconRight" class="right-icon" />
      </div>
      <div class="input-item" @click="family_show = true">
        <div class="label">亲属关系</div>
        <input type="text" placeholder="请选择亲属关系" :value="family_text" readonly />
        <img :src="IconRight" class="right-icon" />
      </div>
    </div>
    <!-- 学校 -->
    <!-- <van-popup v-model="school_show" position="bottom">
      <van-picker
        show-toolbar
        value-key="value"
        @confirm="e => { school_choice = e.code, school_show = false }"
        @cancel="school_show = false"
        :columns="$CodeValue.School"
      />
    </van-popup> -->
    <!-- 班级 -->
    <van-popup v-model="class_show" position="bottom">
      <van-picker
        show-toolbar
        value-key="value"
        @confirm="e => { class_choice = e.code, class_show = false }"
        @cancel="class_show = false"
        :columns="$CodeValue.Class"
      />
    </van-popup>
    <!-- 家庭关系 -->
    <van-popup v-model="family_show" position="bottom">
      <van-picker
        show-toolbar
        value-key="value"
        @confirm="e => { family_choice = e.code, family_show = false }"
        @cancel="family_show = false"
        :columns="$CodeValue.Family"
      />
    </van-popup>
  </div>
</template>

<script>
  import { SetImage } from '@/utils/Image'
  export default {
    data () {
      return {
        sex: '',
        school_show: false,
        school_choice: '',
        class_show: false,
        class_choice: '',
        family_show: false,
        family_choice: '',
        name: ''
      }
    },
    watch: {
      choice () {
        this.Reset()
      }
    },
    props: {
      choice: null,
      schoolname: null
    },
    methods: {
      Reset () {
        this.sex = ''
        this.school_choice = ''
        this.class_choice = ''
        this.family_choice = ''
        this.name = ''
        console.log('Reset')
      }
    },
    computed: {
      school_text () {
        return this.$FilterCode('School', this.school_choice)
      },
      class_text () {
        return this.$FilterCode('Class', this.class_choice)
      },
      family_text () {
        return this.$FilterCode('Family', this.family_choice)
      },
      ...SetImage(['IconRight'])
    }
  }
</script>

<style lang="less" scoped>
  .input-item {
    .h(1.05rem);
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    &:last-child {
      border: none;
    }
    .label {
      .w(1.7rem);
      .fz(.3rem);
      .c(#333);
    }
    input {
      flex: 1;
      .fz(.3rem);
    }
    .sex-select {
      flex: 1;
      display: flex;
      align-items: inherit;
      .sex-item {
        .w(1.04rem);
        .h(.46rem);
        .br(.23rem);
        .mr(.4rem);
        .fz(.3rem);
        .c(#999);
        .flex-cc();
        &.active {
          .c(#fff);
        }
        &.boy {
          .bg(#dbf5ff);
          &.active {
            .bg(#00b0f4);
          }
        }
        &.gril {
          .bg(#ffefef);
          &.active {
            .bg(#ff2c4c);
          }
        }
      }
    }
    .right-icon {
      .w(.12rem);
      .h(.2rem);
    }
  }
</style>
